import type { ProjectSummary } from "@/lib/types";

export function isMiscProjectName(name: unknown): boolean {
  return String(name ?? "").trim().toLowerCase() === "misc";
}

export function getMiscProject(projects: ProjectSummary[]): ProjectSummary | null {
  return projects.find((project) => isMiscProjectName(project.project_name)) ?? null;
}

export function getMiscProjectId(projects: ProjectSummary[]): string | null {
  return getMiscProject(projects)?.id ?? null;
}

export function isMiscProjectId(projectId: string | null | undefined, miscProjectId: string | null | undefined): boolean {
  return Boolean(projectId) && Boolean(miscProjectId) && String(projectId) === String(miscProjectId);
}
